import { Diff } from '../utils/rxjs.utils';

export interface ReduxAction {
  type: string;
  payload?: any;
}

export type StateReducer<TState extends {}> = (state: TState, action: ReduxAction) => TState;

export interface DiffReducer<TState, ActionTypes extends string> {
  reducer: (newState: TState, diff: Diff<TState>) => TState;
  ignoredActions: ActionTypes[];
  fields: (keyof TState)[];
}
